import React from 'react';

const About = () => {
    return (
        <div id="about">
            <h2>This about us.</h2>
            <p>Children's nurses care for sick, injured or disabled children and young people. They provide comfort and reassurance to patients and their parents or carers in difficult or stressful circumstances.</p>
            <p>It offers you the chance to make a difference, a high degree of flexibility and a career with excellent employment prospects. "To be able to go into that situation and be able to help calm the child down and assure the parent that everything was ok was incredible." Ewout, a student children's nurse.</p>
        </div>
    );
};

export default About;